import { render, staticRenderFns } from "./LoginBase.vue?vue&type=template&id=267a83f0&scoped=true&"
import script from "./LoginBase.vue?vue&type=script&lang=js&"
export * from "./LoginBase.vue?vue&type=script&lang=js&"
import style0 from "./LoginBase.vue?vue&type=style&index=0&id=267a83f0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a83f0",
  null
  
)

export default component.exports